import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Badge } from "@runcheetah/ui";

type CreativeLayersPanelProps = {
  title: ReactNode;
  count: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

export function CreativeLayersPanel({ title, count, actions, children }: CreativeLayersPanelProps) {
  return (
    <section
      className="motion-safe:animate-[inspector-fade-in_0.12s_ease-out] overflow-hidden rounded-3xl border border-border/70 bg-background/82 shadow-[0_10px_26px_rgba(19,34,49,0.045)]"
      aria-label={typeof title === "string" ? title : undefined}
    >
      <header className="border-b border-border/60 bg-[#fffdf8]/70 px-4 py-3">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-foreground/48">
                {title}
              </div>
              <Badge
                shape="pill"
                variant="outline"
                className="rounded-full px-2 py-0.5 text-[10px]"
              >
                {count}
              </Badge>
            </div>
            <p className="mt-1.5 text-xs leading-5 text-foreground/48">
              <FormattedMessage
                id="creativeLayersPanel.description"
                defaultMessage="Reorder, hide, or select layers while keeping properties visible below."
              />
            </p>
          </div>
        </div>
        {actions ? <div className="mt-3 grid gap-2 [&>button]:w-full">{actions}</div> : null}
      </header>
      <div className="p-3">{children}</div>
    </section>
  );
}
